import { useEffect, useState } from 'react';

import { useUpdateBrandAsset } from '@pages/home-page/hooks/use-update-brand-asset';

import { Label, LabelList } from '../types';

interface UseApplyLabelsProps {
  assetId: number;
  initialLabels?: Label[];
}

export const useApplyLabels = ({
  assetId,
  initialLabels = [],
}: UseApplyLabelsProps) => {
  const [selectedLabelList, setSelectedLabelList] = useState<LabelList>(() => {
    // Convert initialLabels array to LabelList format
    const labelsMap: LabelList = {};
    initialLabels.forEach((label: Label) => {
      labelsMap[label.id.toString()] = {
        id: label.id,
        name: label.name,
        parentId: label.parentId,
      };
    });

    return labelsMap;
  });

  // Update selectedLabelList when initialLabels changes(when label is deleted/edited)
  useEffect(() => {
    const labelsMap: LabelList = {};
    initialLabels.forEach((label: Label) => {
      labelsMap[label.id.toString()] = {
        id: label.id,
        name: label.name,
        parentId: label.parentId,
      };
    });

    setSelectedLabelList(labelsMap);
  }, [initialLabels]);

  const { mutate: updateBrandAsset } = useUpdateBrandAsset();

  const handleLabelUpdate = (updatedLabels: LabelList) => {
    setSelectedLabelList(updatedLabels);

    // Convert LabelList to array of Label objects
    const labels = Object.values(updatedLabels).map(label => ({
      id: label.id,
      name: label.name,
      parentId: label.parentId,
    }));

    // Call the API to update the asset with new labels
    updateBrandAsset({
      assetId,
      labels,
    });
  };

  return {
    selectedLabelList,
    setSelectedLabelList,
    handleLabelUpdate,
  };
};
